import { logger } from "@src/shared/helpers/logger";
import { isNullish } from "radashi";
import { engine } from "../..";
import { getSuggestionsArgsParams } from "./getSuggestionsArgsParams";
import { ValveSuggestionArgsOptions } from "./initSuggestionArgs";

export function initControlValvesSuggestionArgs({
  filters,
  ...valveSuggestionArgs
}: ValveSuggestionArgsOptions) {
  if (isNullish(filters.flow)) {
    logger.warn(
      "Not initializing control valves suggestions args because of missing filters",
    );
    return { cleanup() {}, currentSelection: null, suggestionArgs: null };
  }
  const { cleanup, currentSelection, params } = getSuggestionsArgsParams({
    filters,
    ...valveSuggestionArgs,
  });
  const args = new engine.CvSuggestionArgs(...params);
  args.flow = filters.flow;

  if (filters.useKvsOrDp === "dp" && !isNullish(filters.dp)) {
    args.dp = filters.dp;
  }
  if (filters.useKvsOrDp === "kvs" && !isNullish(filters.kvs)) {
    args.kvs = filters.kvs;
  }

  return {
    cleanup() {
      cleanup();
      args.delete();
    },
    currentSelection,
    suggestionArgs: args,
  };
}
